// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle4 from "../../randing/RandingStyle4";

function Randing130({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/130/250318(1).jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/130/250318(2).gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/130/250318(3).jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/130/250318(4).jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/130/250318(5).jpg`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/red/applyButton.png`}
      qTitleColor="#fe0033"
      qOptionColor="blue"
      formFieldColor="white"
      companyName="본원"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      benefitInfoPosition="bottom"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      eventDates={true}
    />
  );
}

export default Randing130;
